/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import DataVaxiomTxCardFieldDefinitionsCardWrite from 'DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/Item/EditAction/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let txCardFieldDefinitionIdValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'id',
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 height="auto"
 width={500}
>
{childProps => (
<DataVaxiomTxCardFieldDefinitionsCardWrite
{...childProps}
  viewPath={`${viewPath}/DataVaxiomTxCardFieldDefinitionsCardWrite`}
 data="tx_card_field_definition.id"
 id={txCardFieldDefinitionIdValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
)}
</TysiaModal>
{children}
</React.Fragment>)
}